module.exports = __webpack_public_path__ + "static/img/CAMDEN_PAINT.70a9646.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CAMDEN_PAINT.jpg
// module id = YJKL
// module chunks = 0